import React from 'react'
import { Link } from 'react-router-dom'
import registerVector from '../../Assets/registerVector.png'
import googleIcon from '../../Assets/iconGoogle.svg'
import mail from '../../Assets/mailGrey.svg'
import key from '../../Assets/key.svg'
import eye from '../../Assets/eye.svg'

import './Register.css'

const Register = () => {
    return (
        <div className='registerContainer'>
            <div className="registerFormContainer">

                <div className="registerHeader">
                    <h1>Register Now!</h1>
                    <p>Welcome to Nidaan, Please enter your details</p>
                </div>
                
                <div className="registerForm">

                    <button><img src={googleIcon} alt="" />Continue with google</button>

                    <div className="or">
                        <hr />
                        <p>Or</p>
                        <hr />
                    </div>

                    <form className='register' action="">

                        <div className="registerInputContainer" id='registerInputEmail'>
                            <img src={mail} alt="" className='lIcon' />
                            <input type="text" placeholder='Enter Your Email' />
                        </div>

                        <div className="registerInputContainer">
                            <img src={key} alt="" className='lIcon' />
                            <input type="password" placeholder='Enter Password' />
                            <img src={eye} alt="" className='key' />
                        </div>

                        <div className="registerInputContainer">
                            <img src={key} alt="" className='lIcon' />
                            <input type="password" placeholder='Confirm Password' />
                            <img src={eye} alt="" className='key' />
                        </div>

                        <button>Register Now</button>
                    </form>
                    
                    <p className="switch">Alread have account? <Link to='/signin'>Sign in</Link></p>
                </div>

            </div>

            <div className="registerImg">
                <div className="imgText">
                    <h4>Nidaan</h4>
                    <p>One and only Advance AI healthcare Solution</p>
                </div>
                <img src={registerVector} alt="" />
            </div>
        </div>
    )
}

export default Register